import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Theme } from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Link as MuiLink } from "@material-ui/core";
import classNames from "../../utils/classNames";
import { ThemeStyle } from "@material-ui/core/styles/createTypography";

const styles = (theme: Theme) =>
  createStyles({
    link: {
      textDecoration: "none",
      color: theme.palette.primary.main
    }
  });

type Props = {
  classes?: any;
  className?: string;
  color?: string;
  id: string;
  label: string;
  url?: string | null;
  onClick?: () => void;
  variant?: ThemeStyle;
};

const Link = (props: Props) => {
  const {
    classes,
    className,
    color,
    id,
    label,
    url,
    onClick,
    variant = "body2"
  } = props;
  const colorStyles = { color };
  return (
    <MuiLink
      id={id}
      className={classNames(className)}
      color="primary"
      component="span"
      data-test-control={id}
      style={colorStyles}
      underline="hover"
      variant={variant}
      onClick={onClick}
    >
      {onClick ? (
        label
      ) : (
        <RouterLink
          className={classNames(classes.link, colorStyles)}
          style={colorStyles}
          to={url ? url : "#"}
        >
          {label}
        </RouterLink>
      )}
    </MuiLink>
  );
};

const styled = withStyles(styles)(Link);
export { styled as Link };
